// Azure migration: update API endpoint and key for Azure resources
export const domain = 'https://apiazr.tis.coke.com';
export const stage = 'prod';
export const featureFlags = {
  authorization: true
};
